import { render, staticRenderFns } from "./SubtitleTextEditor.vue?vue&type=template&id=ef874190&"
import script from "./SubtitleTextEditor.vue?vue&type=script&lang=js&"
export * from "./SubtitleTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./SubtitleTextEditor.vue?vue&type=style&index=0&id=ef874190&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports